import React from "react";
import { connect } from "react-redux";
import { reduxForm, change } from "redux-form";

import { answerRequest } from "../../actions/requestActions";
import { tokenCheck } from "../../apis/backend"

import Form from "../CustomViews/Form";

const formName = "pinForm";
const PinForm = reduxForm({ form: formName })(Form);

class AnswerRequest extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            render: false,
            messages: []
        };
    }

    componentDidMount() {
        tokenCheck(this.props.match.params.token)
        .then(() => this.setState({ render: true }))
        .catch(line => this.setState({
            render: true,
            messages: [{ error: true, line }]
        }));
    }

    onSubmit = (formValues, onLoginError) => this.props.answerRequest(this.props.match.params.token, formValues,
        () => {
            this.props.change(formName, "pin", "");
            this.setState({ messages: [{ error: false, line: "Pomyślnie wykonano operację"}] })
        },
        error => {
            this.props.change(formName, "pin", "");
            onLoginError(error);
        }
    );

    renderMessages = () => this.state.messages.map((message, index) => {
        return (
            <div key={index} className={`ui ${message.error ? "error" : "positive"} message`}>
                <p>{message.line}</p>
            </div>
        );
    });

    render() {
        if (this.state.render) {
            return (
                <React.Fragment>
                    <div className="ui secondary pointing menu">
                        <div className="ui container">
                            <h3 className="item">Podaj PIN do potwierdzania operacji przez email</h3>
                        </div>
                    </div>
                    <div className="ui container">
                        {(this.state.messages.length) ? null : (
                            <PinForm onSubmit={this.onSubmit} label="Wykonaj" fields={[
                                { name: "pin", type: "password", label: "Pin:", placeholder:"Wpisz pin...", autofocus: true }
                            ]} />)
                        }
                        {this.renderMessages()}
                    </div>
                </React.Fragment>
            );
        } 
        else return null;
    }
}

export default connect(null, { change, answerRequest })(AnswerRequest);